export const namespace = 'activityLog'
